import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, BUTTON_SIZE, ActionButtons } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';

var css_248z = ".sn1W2{width:212px}.sn1W2.k2cZp{width:100%}.SkTSe{display:flex;height:32px;justify-content:space-between}[dir] .SkTSe{margin-top:12px}[dir] .SkTSe.iZw9F{margin:20px 0 0}.SkTSe.SMqTU{width:100%}[dir] .SkTSe.SMqTU{margin:0;padding-top:12px}.SkTSe.j3OXt{flex-direction:row-reverse}";
var styles = {"actionButtons_wrapper":"sn1W2","actionButtons_wrapper_mobile":"k2cZp","LinkButtons_wrapper":"SkTSe","multiSelectLinkPanel_wrapper":"iZw9F","LinkButtons_wrapper_mobile":"SMqTU","LinkButtons_wrapper_row_reverse":"j3OXt"};
styleInject(css_248z);

class LinkActionsButtons extends PureComponent {
  constructor(props) {
    super(props);
    this.styles = mergeStyles({ styles, theme: props.theme });
  }
  render() {
    const { styles: styles2 } = this;
    const {
      isActive,
      t,
      tabIndex,
      isDoneButtonEnable,
      onCancel,
      onDelete,
      onSave,
      basicLinkPanel,
      hideUrlInput,
      isMobile,
      basicDisplay
    } = this.props;
    const removeButtonText = t("LinkPanelContainer_RemoveButton");
    const showRemoveButton = isActive && !hideUrlInput && !isMobile;
    const saveLabel = t("SettingsPanelFooter_Save");
    return basicDisplay && !isMobile ? /* @__PURE__ */ React.createElement(
      Button,
      {
        dataHook: "actionButtonSave",
        disabled: !isDoneButtonEnable,
        onClick: onSave,
        size: BUTTON_SIZE.medium,
        theme: this.theme
      },
      saveLabel
    ) : /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles2.LinkButtons_wrapper, {
          [styles2.LinkButtons_wrapper_mobile]: isMobile,
          [styles2.LinkButtons_wrapper_row_reverse]: !showRemoveButton,
          [styles2.multiSelectLinkPanel_wrapper]: !basicLinkPanel
        })
      },
      showRemoveButton && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        Button,
        {
          tabIndex,
          "data-hook": "linkPanelContainerRemove",
          onClick: onDelete,
          theme: this.theme,
          secondary: true,
          borderless: true
        },
        removeButtonText
      )),
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classNames(styles2.actionButtons_wrapper, {
            [styles2.actionButtons_wrapper_mobile]: isMobile
          })
        },
        /* @__PURE__ */ React.createElement(
          ActionButtons,
          {
            size: BUTTON_SIZE.tiny,
            isMobile,
            onCancel,
            onSave,
            theme: this.theme,
            disableSave: !isDoneButtonEnable,
            t
          }
        )
      )
    );
  }
}
LinkActionsButtons.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  isActive: PropTypes.bool,
  theme: PropTypes.object.isRequired,
  t: PropTypes.func,
  tabIndex: PropTypes.number,
  isDoneButtonEnable: PropTypes.bool,
  basicLinkPanel: PropTypes.bool,
  hideUrlInput: PropTypes.bool,
  isMobile: PropTypes.bool,
  cancelLabel: PropTypes.string,
  saveLabel: PropTypes.string,
  basicDisplay: PropTypes.bool
};

export { LinkActionsButtons as default };
//# sourceMappingURL=LinkActionsButtons.js.map
